import { Text } from "pixi.js"
import SimpleEntity, { SimpleEntityOptions } from "../SimpleEntity"

export type ParticleEffectEntityOptions = { lifespan?: number } & SimpleEntityOptions

export default class ParticleEffectEntity extends SimpleEntity {

	initialLifespan
	lifespan

	static baseSize = 20

	constructor({ lifespan = 2.5, size = 20, ...rest }: ParticleEffectEntityOptions) {
		super({
			...rest,

			size,
		})
		this.lifespan = lifespan
		this.initialLifespan = lifespan
	}

	damage(amt: number) { }

	tick(delta: number) {
		super.tick(delta)

		this.lifespan -= delta

		if (this.lifespan <= 0) {
			this.kill()
		}

		if (this.graphicsMounted && this.graphics) {
			const scale = (Math.max(0, this.lifespan) / this.initialLifespan)
			this.graphics.scale.x = scale
			this.graphics.scale.y = scale
		}
	}

	createGraphics() {
		const text = new Text(this.symbol, { fontFamily: 'Segoe UI Emoji', fontSize: this.size, align: 'center' })
		text.anchor.set(0.5)
		return text
	}

}